export default __webpack_public_path__ + "static/media/default-bg.014786ff.webp";